module.exports = __webpack_public_path__ + "static/SaltStack_Protect_black-1da095b1b574521eb21320d0a8869f5d.png";